namespace GeniuzPOS.Lookups {
    export namespace VwPosFuncService {
        export const baseUrl = 'Lookups/VwPosFunc';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwPosFuncRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwPosFuncRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwPosFunc/Retrieve",
            List = "Lookups/VwPosFunc/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwPosFuncService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
